import { Container } from "@mui/material";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { Toast } from "../overlays/toast";
import { ResponsiveRow } from "../../constants/layout.constants";

// Using Inline Styling
const useStyles = makeStyles((theme) => ({
  navbar: {
    backgroundColor: "#037171",
    minHeight: "6vmin",
    fontSize: `calc(10px + 2vmin)`,
    color: "white",
  },
  menuButton: {
    color: "white!important",
  },
  subMenu: {
    "& .MuiPaper-root": {
      backgroundColor: "#037171",
      color: "white",
    },
  },
  subMenuLink: {
    color: "white",
    textDecoration: "none",
  },
  secureContainer: {
    minHeight: "92.5vmin",
  },
  unsecureContainer: {
    // minHeight: "100vmin",
    minHeight: "92.5vmin",
    width: "100vw",
    margin: 0,
    padding: 0,
  },
}));

export default function PublicLayout(props) {
  const { children, showToast = true } = props;
  const classes = useStyles();
  const message = useSelector(state => state.message);
  const modals = useSelector(state => state.modals);
  const isAnyModalOpen = modals.openModals > 0;

  return (
    <ResponsiveRow
      sx={{
        position: "relative",
        maxHeight: "100vh",

        flexDirection: "column",
        flexWrap: "nowrap",

        margin: 0,
        padding: 0,

        justifyContent: "flex-start",
        alignItems: "center",

        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      {!isAnyModalOpen && message.display && showToast && <Toast />}
      <Container
        className={classes.unsecureContainer}
        maxWidth="100%"
        disableGutters={true}
      >
        {children}
      </Container>
    </ResponsiveRow>
  );
}
